<template>
  <div class="switch-container">
    <label for="bCategorieLabel">{{label}}</label>
    <div class="switch">
        <input type='hidden' value='0' :name="inputid">
        <span class="switch-action-name">Non</span>
        <input type="checkbox" @click="checkevent($event)" v-model="checked" :id="inputid+'_1'" :name="inputid" value="1" :class="inputid">
        <label :for="inputid+'_1'"></label>
        <span class="switch-action-name">Oui</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SwitchInput',
  props: {
    label: {
      type: String,
      default: 'Label'
    },
    inputid: {
      type: String,
      default: 'switch'
    },
    check: {},
    trueVal: {},
    falseVal: {},
  },
  data() {
    return {
      checked: false,
    }
  }, 
  created() {
    if(this.$props.check === this.$props.trueVal) {
      this.checked = true;
    }
  },  
  methods: {
    checkevent(event) {
      if(event.target.checked) {
        this.$emit('change', this.$props.trueVal);
      } else {
        this.$emit('change', this.$props.falseVal);
      }
    }
  }
}
</script>

<style scoped>
/**
 * SWITCH
 */
 .switch {
  margin-top: 4px;
  margin-bottom: 4px;
}
.switch input[type="checkbox"] {
  height: 0;
  width: 0;
  visibility: hidden;
}
.switch .switch-action-name {
  float: left;
  font-size: 0.9rem;
  vertical-align: middle;
  margin-top: 5px;
}
.switch label {
  cursor: pointer;
  text-indent: -9999px;
  width: 50px;
  height: 26px;
  background: rgba(0, 0, 0, 0.1);
  border: solid 1px rgba(0, 0, 0, 0.09);
  display: block;
  border-radius: 100px;
  position: relative;
  float: left;
  margin: 0px 10px 0px 10px;
}
.switch label:after {
  content: "";
  position: absolute;
  top: 2px;
  left: 2px;
  width: 20px;
  height: 20px;
  background: rgba(0, 0, 0, 0.3);
  border-radius: 90px;
  transition: 0.3s;
}
.switch input:checked + label {
  background: rgba(73,168,68,1);
}
.switch input:checked + label:after {
  left: calc(100% - 3px);
  transform: translateX(-100%);
  background-color: rgba(255, 255, 255, 0.9);
}
.switch:after {
  content: "";
  clear: both;
  display: block;
}
</style>